import ButtonPrimary from '@/components/common/button/Primary'
import DialogLightTip from '@/components/common/dialog/LightTip'
import DialogEmpty from '@/components/common/dialog/Empty'

const components = {
  ButtonPrimary,
  DialogLightTip,
  DialogEmpty,
}

export default function(Vue) {
  Object.keys(components).forEach((key) => {
    Vue.component(components[key].name, components[key])
  })
}
